import React, {
  useContext,
  useEffect,
  useState
} from "react";
import {
  Button,
  Grid,
  Box,
  Modal,
  Backdrop,
  CircularProgress,
  LinearProgress,
  TextareaAutosize,
  FormLabel
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles
} from "@material-ui/core/styles";
import {
  FormProvider,
  useForm
} from "react-hook-form";

import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import FormSelect from "../../../Controls/Select";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import history from "../../../utils/History";
import {
  useParams,
  useLocation
} from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Roles from "../../../constants/Roles";
import {
  findByNumeroCedula
} from "services/DatosPersonalesService";
import {
  trackPromise
} from "react-promise-tracker";
import Checkbox from '@material-ui/core/Checkbox';
import * as yup from "yup";
import {
  yupResolver
} from "@hookform/resolvers";
import UserContext from "../../../context/User/UserContext";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FormCheckBox from "../../../Controls/Checkbox";
import FormDatePicker from "../../../Controls/DatePicker";
import axios from "axios";
import DeleteDialog from "../../../dialogs/DeleteDialog";
import FormAutocomplete from "../../../Controls/Autocomplete";
import {
  getCarrerasProgramas,
  getTutores,
  getEstudiantes
} from "services/ConvenioService";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  modal: {
    position: 'absolute',
    width: 800,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus: {
      outline: 'none'
    },
    outline: 'none'
  }
}));
const validationSchema = yup.object().shape({
  convenioEstudiante: yup.object().required("El campo estudiante es requerido"),
  convenioTutor: yup.object().required("El campo Tutor es requerido"),
  totalHoras: yup.number().required("El campo totalHoras  es requerido"),
  establecimiento: yup.object().required("El campo solicitud de plaza es requerido"),
  anio: yup.number().required("El campo Registro Profesional es requerido")
});

const DIAS_SEMANA2 = [{
    id: 1,
    label: "lunes",
  },
  {
    id: 2,
    label: "martes",
  },
  {
    id: 3,
    label: "miercoles",
  },
  {
    id: 4,
    label: "jueves",
  },
  {
    id: 5,
    label: "viernes",
  },
  {
    id: 6,
    label: "sabado",
  },
  {
    id: 7,
    label: "domingo",
  },
];

const Form = () => {
  const classes = useStyles();
  const [carreraOptions, setCarreraOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [detalleResponseData, setDetalleResponseData] = useState({});
  const [practicaDetalleResponseData, setPracticaDetalleResponseData] = useState({});

  const params = useParams();
  const methods = useForm({
    resolver: yupResolver(validationSchema)
  });
  const {
    handleSubmit,
    errors,
    setValue,
    reset,
    getValues
  } = methods;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const {
    hasRole
  } = useAuth();
  let {
    state
  } = useLocation();
  const [idTutor, setIdTutor] = useState();
  const [fechaCreacion, setFechaCreacion] = useState();
  const [usuarioCreacion, setUsuarioCreacion] = useState();
  const {
    userData
  } = useContext(UserContext);
  const isAdmin = userData && userData.role.descripcion === "ROLE_ADMIN";
  const methods2 = useForm({
    shouldUnregister: false,
    //  resolver: yupResolver(validationSchema),
  });
  const [isCargarHorario, setIsCargarHorario] = useState(false);
  const [horariosElegido, setHorariosElegido] = useState([]);
  const {
    handleSubmit: handleSubmit2,
    errors: errors2,
    reset: reset2,
    setValue: setValues2,
    getValues: getValues2
  } = methods2;
  const [timeDesde, setTimeDesde] = useState("00:00");
  const [timeHasta, setTimeHasta] = useState("00:00");
  const [horarios, setHorarios] = useState([]);
  const [horariosTutor, setHorariosTutor] = useState([]);
  const [isNotReg, setIsNotReg] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const [indexx, setIndex] = useState();
  const [deshabilitarAgregar, setDeshabilitarAgregar] = useState(true);
  const [tutoresConvenioList, setTutotresConvenioList] = useState([]);
  const [estudiantesResponseData, setEstudiantesResponseData] = useState([]);
  const [plazasList, setPlazasList] = useState([]);
  const [carreraId, setCarreraId] = useState();
  const [fechaDes, setFechaDes] = useState();
  const [fechaHas, setFechaHas] = useState();
  const [practicaResponseData, setPracticaResponseData] = useState({});
  const [practicaDetalleId, setPracticaDetalleId] = useState({});
  const [plazaElegida, setPlazaElegida] = useState();
  const [disabledPlazas, setDisabledPlazas] = useState(false);
  const [disabledTutor, setDisabledTutor] = useState(false);
  const [disabledEstudiante, setDisabledEstudiante] = useState(false);
  const [practicaId, setPracticaId] = useState();

  const [configResponse, setConfigResponse] = useState();
  
  const [alumnosPorTutor, setAlumnosPorTutor] = useState();

  const uniqueConvenioEstudiantes = (estudiantes = []) => {
    const vistos = new Set();
    return estudiantes.filter((item) => {
      const key = `${item?.convenio?.id || ""}-${item?.estudiante?.id || item?.estudiante?.cedulaIdentidad || ""}`;
      if (vistos.has(key)) {
        return false;
      }
      vistos.add(key);
      return true;
    });
  };
  
  useEffect(() => {

    const load = () => {
      // console.log(state?.edit);

      try {
        !isReadOnly?setDisabledTutor(true) : setDisabledTutor(false);

        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit);
          setIsReadOnly(state?.readOnly);
          setIsCargarHorario(false);
          setValuesForEdit();
          loadAllSolicitudes();
        } else {
          getDetallesPractica();
        }
        if (state?.carrera) {
          setCarreraId(state?.carrera);
        }
        if (state?.fechaDesde) {
          setFechaDes(state?.fechaDesde);
          setFechaHas(state?.fechaHasta);
          const formValues = {
            fechaDesdeModal: state?.fechaDesde,
            fechaHastaModal: state?.fechaHasta,
            anio: state?.anio
          };
          Object.keys(formValues).forEach((field) => {
            setValue(field, formValues[field]);
          });
        }
        getServerData();
        loadAllSolicitudes();
        setPracticaId(params.practicaId);
      } catch (error) {
        // console.log(error);
      }
    };

    load();
  }, []);
  const getDetallesPractica = async () => {
    try {
      /* verificar si existen estudiantes en este cronograma para obtener la misma solicitud */
      let url = `/practicas-detalles/${params.practicaId}/practicas-detalles`;
      const responseDetallesData = await trackPromise(DnerhsApi.get(url));
      if (responseDetallesData.data.length > 0) {
        const formValues = {
          establecimiento: responseDetallesData.data[0].solicitudPlaza
        };
        Object.keys(formValues).forEach((field) => {
          setValue(field, formValues[field]);
        });
        // setDisabledPlazas(true);

      }
    } catch (err) {
      console.log("Error al cargar pagina", err);
    }
  };

  const URL_BASE_CONFIG = "/configuraciones/"

  const getServerData = async () => {
    console.log('params', params);
    try {
      setDeshabilitarAgregar(true);

      let [responseTutores, responseEstudintes] = await Promise.all([
        getTutores(params.convenioId, state?.carrera.trim()),
        getEstudiantes(params.convenioId, state?.carrera.trim())
      ])
      setTutotresConvenioList(responseTutores.data);
      console.log('responseTutores.data', responseTutores.data);
      setEstudiantesResponseData(uniqueConvenioEstudiantes(responseEstudintes.data));

      // Obtener la última configuración

      const {
        data: configResponseData
      } = await DnerhsApi.get(URL_BASE_CONFIG + 'ultima-configuracion');

      console.log('configResponseData', configResponseData);

      setConfigResponse(configResponseData);

      setAlumnosPorTutor(configResponseData.alumnosPorTutor);

      const formValues = {
        alumnosPorTutor: configResponseData.alumnosPorTutor,
      };

      console.log('formValues', formValues);

      // Object.keys(formValues).forEach((field) => {
      //   console.log(field);
      //   setValue(field, formValues[field]);
      // });
      console.log(isUpdate);
      console.log(state.edit);

      if (state.edit == true) {

        // Obtener la práctica
        const {
          data: practicaDetalleResponseData
        } = await DnerhsApi.get(`/practicas-detalles/${params.practicaDetalleId}`);
        setPracticaDetalleResponseData(practicaDetalleResponseData);
        console.log('practica detalle', practicaDetalleResponseData);

      } else {

        // Obtener la práctica
        const {
          data: practicaResponseData
        } = await trackPromise(DnerhsApi.get(
          `/convenios/practicas/${params.practicaId}`
        ));

        console.log('practica', practicaResponseData)
        setFechaDes(practicaResponseData.fechaDesde);
        setFechaHas(practicaResponseData.fechaHasta);

      }





    } catch (err) {
      console.log("Error al cargar pagina", err);
    }
  };
  const loadAllSolicitudes = async () => {
    try {
      /* const { data: practicaResponseData } = await trackPromise(DnerhsApi.get(
         `/convenios/practicas/${params.practicaId}`
       ));*/
      let url = `/solicitudes-plazas/${state?.idFormadora}/${state?.carrera}/asignaciones`;
      const response = await trackPromise(DnerhsApi.get(url));
      // console.log('Solicitudes de plazas: ', response.data);

      let arrayListPlazasPut = [];
      let arrayListPlazasPost = [];
      response.data.forEach((u) => {
        // if(u.estado==="Aprobado por DNERHS"  || u.estado==="Utilizado"){

        // console.log('u.practicaId', u.practicaId);
        // console.log('typeof(u.practicaId)', typeof(u.practicaId));
        // console.log('u.estado', u.estado);

        if (u.estado === "Aprobado por DNERHS" || u.estado === "Utilizado") {
          arrayListPlazasPost.push(u);

          // if(typeof(params.practicaId)!= 'undefined' && (u.practicaId!=null  && u.practicaId.toString()===params.practicaId)){
          //   arrayListPlazasPut.push(u);
          // }else{

          //   if(u.practicaId===null ||  u.practicaId===0 || typeof(u.practicaId)=== 'undefined'){
          //     arrayListPlazasPost.push(u);
          //   }
          // }
        }
      })

      // console.log('arrayListPlazasPost', arrayListPlazasPost);
      // console.log('arrayListPlazasPut', arrayListPlazasPut);
      // setPlazasList(arrayListPlazasPost.length>0? arrayListPlazasPost : arrayListPlazasPut);     
      setPlazasList(arrayListPlazasPost);
    } catch (error) {
      //  console.log(error);
    }
  };
  const changeTimeDesde = (e) => {
    setTimeDesde(e.target.value)
  }
  const changeTimeHasta = (e) => {
    setTimeHasta(e.target.value)
  }


  const loadCarreraOptions = (carreras) => {
    setCarreraOptions(
      carreras.map((carrera) => ({
        label: carrera.carreraPrograma.descripcion,
        id: carrera.carreraPrograma.id,
      }))
    );
  }
  const handleOpenDialog = (id, index) => {
    setOpenDialog(true);
    setToDelete(id);
    setIndex(index);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const deleteOne = async () => {
    try {
      let message = "";
      let url = `/practicas-detalles-horarios/${toDelete}`;
   
      const response = await DnerhsApi.delete(url);
      
      message = `Registro con id ${toDelete} eliminado correctamente`;
      Alert.show({
        message,
        type: "success"
      });
      
      // Actualiza el estado de la lista de horarios después de la eliminación
      let listCopy = [...horarios];
      listCopy.splice(indexx, 1); // Elimina el elemento de la lista
      setHorarios(listCopy);
    } catch (error) {
      console.error("Error al eliminar el registro:", error); // Mejor manejo del error
      Alert.show({
        message: "Error al eliminar el registro.",
        type: "error"
      });
    } finally {
      setOpenDialog(false); // Cierra el diálogo de confirmación
      setToDelete(null);    // Limpia la variable toDelete
    }
  };
  
  const setValuesForEdit = async () => {
    try {
      setIsCargarHorario(true);
      setDisabledPlazas(true);
      setDisabledTutor(true);
      setDisabledEstudiante(true);
      let {
        convenioTutorId
      } = params;
      const {
        data: practicaDetalleResponseData
      } = await DnerhsApi.get(`/practicas-detalles/${params.practicaDetalleId}`);
      console.log('practicaDetalleResponseData', practicaDetalleResponseData);
      setPracticaId(practicaDetalleResponseData.practica.id);
      setDetalleResponseData(practicaDetalleResponseData);
      setPracticaDetalleId(practicaDetalleResponseData.id);

      const formValues = {
        convenioEstudiante: practicaDetalleResponseData.convenioEstudiante,
        anio: practicaDetalleResponseData.anio,
        totalHoras: practicaDetalleResponseData.totalHoras,
        convenioTutor: practicaDetalleResponseData.convenioTutor,
        establecimiento: practicaDetalleResponseData.solicitudPlaza,
        fechaDesdeModal: practicaDetalleResponseData.fechaDesde,
        fechaHastaModal: practicaDetalleResponseData.fechaHasta
      };

      setFechaDes(practicaDetalleResponseData.fechaDesde);
      setFechaHas(practicaDetalleResponseData.fechaHasta);


      Object.keys(formValues).forEach((field) => {
        setValue(field, formValues[field]);
      });

      const {
        data: practicaDetalleHorarioIdResponseData
      } = await trackPromise(DnerhsApi.get(
        `/practicas-detalles-horarios/${params.practicaDetalleId}/horarios`
      ));

      setHorarios(practicaDetalleHorarioIdResponseData);
      //se guarda el horario del Tutor
      const {
        data: tutorHorarioResponseData
      } = await trackPromise(DnerhsApi.get(
        `/profesionales-horarios/${practicaDetalleResponseData.convenioTutor.tutor.id}/profesional`
      ));
      setHorariosTutor(tutorHorarioResponseData);
    } catch (error) {
      // console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
    setDeshabilitarAgregar(false);
  }
  const getOptionLabelEstudiantes = (convenio) => {
    return `${convenio.estudiante?.cedulaIdentidad} - ${convenio?.estudiante?.nombres} ${convenio?.estudiante?.apellidos}`;
  }

  const getOptionLabelTutores = (convenio) => {
    return `${convenio.tutor?.cedulaIdentidad} - ${convenio?.tutor?.nombres} ${convenio?.tutor?.apellidos}`;
  }
  const getOptionLabelPlazas = (solicitud) => {
    return `Nro. de Solicitud: ${solicitud?.id} - Establecimiento: ${solicitud?.datosEstablecimiento?.institucionEstablecimiento?.nombreServicio?.nombre}`;
  }
  const onChangeSolicitud = (e, itemx) => {
    if (e != null) {
      let listCopy = [];
      setHorarios(listCopy);
      reset2();
      setDeshabilitarAgregar(false);
      setTimeDesde("00:00");
      setTimeHasta("00:00");
      reset2();
    } else {
      setDeshabilitarAgregar(true);

    }
    setDisabledTutor(false);
  };
  const onChangeTutor = async (e, itemx) => {
    //const auxiliarHorTutor =e.target.value;
    let indice = itemx?itemx.indexOf("-") : null;

    const auxiliarHorTutor = itemx?(itemx.substring(0, indice)) : "";

    if (auxiliarHorTutor != null) {
      const {
        data: tutorHorarioResponseData
      } = await trackPromise(DnerhsApi.get(
        `/profesionales-horarios/cedula/${auxiliarHorTutor}`
      ));
      setHorariosTutor(tutorHorarioResponseData);
    }
  };

  const converToLocalTime = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    //  console.log(new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
    return (new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0] + ' UTC').toISOString());
  }

  const onSubmit = async (data) => {
    // console.log('data: ', data);
    let url = "/practicas-detalles";
    let url_practicas = "/convenios/practicas";
    //let urlEst = "/establecimientos-profesiones-profesionales";
    let auxiliarSolicitud = getValues("establecimiento");

    let auxiliarFechaDes = getValues("fechaDesde");
    let auxiliarFechaHas = getValues("fechaHasta");

    console.log('fechaDes', fechaDes);
    console.log('fechaHas', fechaHas);
    const fecha_hasta = new Date(fechaHas);
    const fecha_desde = new Date(fechaDes);
    /* data.solicitudPlaza=auxiliarSolicitud;
     data.establecimiento=auxiliarSolicitud.datosEstablecimiento.institucionEstablecimiento; */
    const dataForm = {
      solicitudPlaza: auxiliarSolicitud,
      establecimiento: auxiliarSolicitud.datosEstablecimiento.institucionEstablecimiento,
      fechaDesde: fecha_desde,
      fechaHasta: fecha_hasta,
      // fechaDesde: converToLocalTime(fechaDes.toString()),
      // fechaHasta: converToLocalTime(fechaHas.toString()),
      anio: data.anio,
      totalHoras: data.totalHoras,
      convenioEstudiante: data.convenioEstudiante,
      convenioTutor: data.convenioTutor,
      convenioId: data.convenioEstudiante.convenio.id,
      practica: {
        id: practicaId
      }
    };

    // console.log('params', params)

    console.log('dataForm', dataForm);

    try {
      let message = "";
      if (isUpdate) {
        let payloadUpt = {
          ...detalleResponseData,
          ...dataForm
        };
        // console.log('payloadUpt', payloadUpt);
        const result = await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));

        // Obtener la práctica
        const {
          data: practicaDetalleResponseData
        } = await DnerhsApi.get(`/practicas-detalles/${params.practicaDetalleId}`);

        // console.log('practicaDetalleResponseData', practicaDetalleResponseData);
        const {
          data: practicaResponseData
        } = await trackPromise(DnerhsApi.get(
          `/convenios/practicas/${practicaDetalleResponseData.practica.id}`
        ));

        console.log('practicaResponseData', practicaResponseData)

        // Actualizar el campo institucion_establecimiento_id en la tabla "practica" con el id del establecimiento 

        practicaResponseData.institucionEstablecimiento = {
          id: auxiliarSolicitud.datosEstablecimiento.institucionEstablecimiento.id
        };

        const payload_practica = {
          ...practicaResponseData
        };

        // console.log('payload_practica', payload_practica);

        let {
          data
        } = await trackPromise(DnerhsApi.put(url_practicas, {
          ...payload_practica,
        }));


        setDetalleResponseData(result.data);
        message = "Datos guardados exitosamente.";
        Alert.show({
          message,
          type: "success"
        })
        setIsUpdate(true);
      } else {

        dataForm.practica = {
          id: params.practicaId
        };
        dataForm.confirmacion = false;

        const result = await trackPromise(DnerhsApi.post(url, {
          ...dataForm,
        }));

        // Obtener la práctica
        // console.log('params.practicaId', params.practicaId)

        const {
          data: practicaResponseData
        } = await trackPromise(DnerhsApi.get(
          `/convenios/practicas/${params.practicaId}`
        ));

        console.log('practicaResponseData %%%%%%%%', practicaResponseData)

        // Actualizar el campo institucion_establecimiento_id en la tabla "practica" con el id del establecimiento 

        practicaResponseData.institucionEstablecimiento = {
          id: auxiliarSolicitud.datosEstablecimiento.institucionEstablecimiento.id
        };

        const payload_practica = {
          ...practicaResponseData
        };

        // console.log('payload_practica', payload_practica);

        let {
          data
        } = await trackPromise(DnerhsApi.put(url_practicas, {
          ...payload_practica,
        }));


        setPracticaDetalleId(result.data.id);
        setPracticaId(result.data.practica.id)
        setDetalleResponseData(result.data);
        message = "Datos actualizados exitosamente.";
        Alert.show({
          message,
          type: "success"
        });
        setIsCargarHorario(true);
        setIsUpdate(true);
      }
      console.log('practicaResponseData', practicaResponseData);
      //history.goBack();
    } catch (error) {
       console.log(error);
      if (error.response) {
        var message = error.response?.data?.message;
        Alert.show({
          message,
          type: "error"
        })
      } else {
        Alert.showServerError(error);
      }
    }
  }
  const verificar = async (cedula) => {
    const datainstance = axios.create({
      baseURL: `http://sirepro.mspbs.gov.py/webservices/getEstadoRegistro2.php?cedula=${cedula}`,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json"
      },
    });
    const {
      data
    } = await trackPromise(datainstance.get());
    if (data.length > 0) {
      setValue("numeroRegistroProfesional", data?. [0].nroregis);
    } else {
      setValue("numeroRegistroProfesional", "");
    }

  };
  const handleFindDatosTutor = async (event) => {
    let {
      target
    } = event;
    const datainstance = axios.create({
      baseURL: `http://sirepro.mspbs.gov.py/webservices/getEstadoRegistro2.php?cedula=${target.value}`,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json"
      },
    });
    const {
      data: dataReg
    } = await trackPromise(datainstance.get());
    if (dataReg.length > 0) {
      setValue("numeroRegistroProfesional", dataReg?. [0].nroregis);
      const {
        data
      } = await trackPromise(DnerhsApi.get(`/profesional/cedula/${target.value}`));
      if (data) {
        setIdTutor(data.id);
        setFechaCreacion(data.fechaCreacion);
        setUsuarioCreacion(data.idUsuarioCreacion);

        setValue("nombre", data.nombres);
        setValue("apellido", data.apellidos);
        setValue("email", data.email);
        setValue("numeroRegistroProfesional", data.numeroRegistroProfesionalVigente);
      } else {
        handleFindDatosPersonales(target.value);
      }
      setIsNotReg(false);

    } else {
      setValue("numeroRegistroProfesional", "");
      let message = "No se encuentra registro profesional, No se puede continuar";
      Alert.show({
        message,
        type: "error"
      })
      setIsNotReg(true);
    }

  };
  const handleFindDatosPersonales = async (event) => {

    const {
      data
    } = await trackPromise(findByNumeroCedula(event));
    if (data) {
      setValue("nombre", data.nombres);
      setValue("apellido", data.apellidos);
    }
  };


  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }




  // Botón Agregar horario y alumno
  const onSubmit2 = async (data) => {
    console.log('onSubmit2 data', data);
    if (validar(data)) {
      if (validarConTutor(data)) {

          //if(validar(data)){ 
          //reset2();
        if (timeDesde === "00:00" && timeHasta === "00:00") {
            Alert.show({
              message: "Verifique el horario de practica",
              type: "warning"
            })
        } else {

          // Switch
          let switch_alumnos_tutor = false;

          // Valores para comparación
          console.log('validarAlumnosPorTutor');
          console.log('data.dia', data.dia);
          console.log('timeDesde', timeDesde + ':00');
          console.log('timeHasta', timeHasta + ':00');
          console.log('detalleResponseData.convenioTutor.tutor.id', detalleResponseData.convenioTutor.tutor.id);
          console.log('detalleResponseData.fechaDesde', detalleResponseData.fechaDesde);
          console.log('detalleResponseData.fechaHasta', detalleResponseData.fechaHasta);

          let dia_send = data.dia;
          let time_desde_send = timeDesde + ':00';
          let time_hasta_send = timeHasta + ':00';


          // Obtener el tutor ID que se encuentra en detalleResponseData.convenioTutor.id
          console.log('detalleResponseData', detalleResponseData);

          let tutor_id_send = parseInt(detalleResponseData.convenioTutor.tutor.id, 10);

          let fecha_desde_send = detalleResponseData.fechaDesde;
          let fecha_hasta_send = detalleResponseData.fechaHasta;
          // let fecha_desde_send = new Date(detalleResponseData.fechaDesde);
          // let fecha_hasta_send = new Date(detalleResponseData.fechaHasta);


          // console.log('fecha_desde_send con toIsoString', fecha_desde_send.toISOString());
          // console.log('fecha_hasta_send con toIsoString', fecha_hasta_send.toISOString());
          console.log('alumnosPorTutor', alumnosPorTutor);
          console.log('Todos:', dia_send, time_desde_send, time_hasta_send, tutor_id_send, detalleResponseData.fechaDesde, detalleResponseData.fechaHasta);
          // console.log('Todos:', dia_send, time_desde_send, time_hasta_send, tutor_id_send, fecha_desde_send, fecha_hasta_send);

          // Obtener los horarios de cada una de las prácticas relacionadas a los valores anteriores
          const { data: practicasDetallesHorariosFiltrados } = await trackPromise(DnerhsApi.get(
            `/practicas-detalles-horarios/filter?dia_send=${dia_send}&time_desde_send=${time_desde_send}&time_hasta_send=${time_hasta_send}&tutor_id_send=${tutor_id_send}&fecha_desde_send=${fecha_desde_send}&fecha_hasta_send=${fecha_hasta_send}`
          ));


          // const { data: practicasDetallesHorariosFiltrados } = await trackPromise(DnerhsApi.get(
          //   `/practicas-detalles-horarios/filter?dia_send=${dia_send}&time_desde_send=${time_desde_send}&time_hasta_send=${time_hasta_send}&tutor_id_send=${tutor_id_send}&fecha_desde_send=${fecha_desde_send.toISOString()}&fecha_hasta_send=${fecha_hasta_send.toISOString()}`
          // ));
          console.log('practicaDetalleResponseData', practicaDetalleResponseData);
          console.log('practicasDetallesHorariosFiltrados', practicasDetallesHorariosFiltrados);
          console.log('practicasDetallesHorariosFiltrados.lenght', practicasDetallesHorariosFiltrados.length);
          console.log('alumnosPorTutor', alumnosPorTutor);
          // if (switch_alumnos_tutor){
         
          if (practicasDetallesHorariosFiltrados.length <  15){ // alumnosPorTutor){
            console.log('Es menor a alumnosPorTutor');
            switch_alumnos_tutor = true;
          } else {
            console.log('Es mayor o igual alumnosPorTutor');
            switch_alumnos_tutor = false;
          }
         //  switch_alumnos_tutor = true;
          // https://ejemplo.com/productos?categoria=electronicos&precio=menor-100


          // const { data: practicasDetallesHorariosFiltrados } = await trackPromise(DnerhsApi.get(
          //   `/practicas-detalles-horarios`
          // ));



          // Actualizar el valor de topeAlumnosTutor con los cálculos realizados con los horarios obtenidos de la BD.

          // Grabar en la base de datos practicas-detalles-horarios
          if (switch_alumnos_tutor){

            // Definir la ruta de la api
            let url = "/practicas-detalles-horarios";
            detalleResponseData.practica.convenio = detalleResponseData.convenioTutor.convenio;

            // Construir el contenido de la información a enviar para grabar
            const payload = {
              dia: data.dia,
              practicaDetalle: detalleResponseData,
              horarioDesde: timeDesde + ':00',
              horarioHasta: timeHasta + ':00',
              tutor: {id: tutor_id_send},
              // topeAlumnosTutor debe ser automático
              topeAlumnosTutor: 1,
              fechaDesde: fecha_desde_send,
              fechaHasta: fecha_hasta_send
            };


            try {

              let message = "";
              let result = await DnerhsApi.post(url, {
                ...payload,
              });
              let resultado = {
                id: result.data.id,
                // establecimiento: establecimientoDatoId,
                dia: result.data.dia,
                horarioDesde: result.data.horarioDesde,
                horarioHasta: result.data.horarioHasta
              };

              setHorarios([...horarios, resultado]);
              setTimeDesde("00:00");
              setTimeHasta("00:00");
              reset2();

              message = "Datos guardados exitosamente.";

              Alert.show({
                message,
                type: "success"
              })


            } catch (error) {
              // console.log(error);
              if (error.response) {
                var message = error.response?.data?.message;
                Alert.show({
                  message,
                  type: "error"
                })
              } else {
                Alert.showServerError(error);
              }
            }
          } else {
            Alert.show({
              message: "Ha alcanzado el límite máximo de estudiantes por tutor en el mismo horario",
              type: "warning"
            });
          }
        }
      }
    }
  };


  // Validar y retornar true si pasa la comprobación y actualizaciones
  const validarAlumnosPorTutor =  async (data) => {
    let switch_alumnos_tutor = false;
    // setIdTutor(detalleResponseData.convenioTutor.id);
    // console.log('idTutor', idTutor);
    console.log('validarAlumnosPorTutor');
    console.log('data.dia', data.dia);
    console.log('timeDesde', timeDesde + ':00');
    console.log('timeHasta', timeHasta + ':00');
    

    // Obtener los horarios de cada una de las prácticas.
    const { data: practicaDetalleHorario } = await trackPromise(DnerhsApi.get(
      `/practicas-detalles-horarios`
    ));

    console.log('practicaDetalleHorario', practicaDetalleHorario);

    
    // 1) Utilizar estos datos para realizar una búsqueda y obtener las practicas-detalles-horarios que coincidan con los parámetros brindados.

    // 2) Actualizar y retornar un valor de la base de datos que indique cuál será el siguiente número a registrar en topeAlumnosTutor.

    // 3) Utilizar el valor retornado para poder asignar a topeAlumnosTutor una vez que realice la comprobación.    
    return false;

    
    if(!switch_alumnos_tutor){
      // si encuentra que ya alcanzó el límite el "switch_alumnos_tutor" estará false
      console.log('false');
      return false;
    } else {
      // si encuentra que no alcanzó el límite debe actualizar los registros que encuentre con el mismo horario
      console.log('true');
      return false;
    }
    
  }



  const validar = (data) => { //horario data debe coincidir o incluise dentro del horario solicitud
    const auxiliarPlazas = getValues("establecimiento");
    if (auxiliarPlazas != null) {
      setPlazaElegida(auxiliarPlazas);
      const horas = auxiliarPlazas.solicitudPlazaAsignacionList;
      setHorariosElegido(horas);
      //ver como llegar al listado de el seleccionado
      let bandera = false;
      /*if(timeDesde==="00:00" && timeHasta==="00:00" ){
        Alert.show({
          message : "Verifique el  horario de practica",
          type : "warning"
        })
        return false;
      }else{*/
      let contador = 0;
      horas.forEach((el) => {
        //  console.log(el);
        contador++;
        if (((data.dia).toString()) == el.dia) {
          let horad = timeDesde.split(/:/);
          let horah = timeHasta.split(/:/);
          let horarioDefinidoD = (el.horarioDesde.toString()).split(/:/);
          let horarioDefinidoH = (el.horarioHasta.toString()).split(/:/);
          let fecha1;
          let fecha2;
          let fecha3;
          let fecha4;
          // control solo cada 24 hs
          if ((Number(horad[0]) >= Number(horah[0])) || ((Number(horad[0]) === Number(horah[0])) && (Number(horad[1]) >= Number(horah[1])))) { //9/1 a 3/2     8/1 a 15/1
            // 18:00(d1) a  03:00(d2) or 18:00(d1) a 18:00(d2)
            //fecha1 = new Date('1/1/1990 '+ el.horarioDesde.toString());
            fecha2 = new Date('1/1/1990 ' + timeDesde);
            //fecha3 = new Date('1/2/1990 '+ el.horarioHasta.toString());
            fecha4 = new Date('1/2/1990 ' + timeHasta);
          } else {
            //00:01(d1) a 23:59(d1) d1 de 0 a 24 hs 
            //fecha1 = new Date('1/1/1990 '+ el.horarioDesde.toString());
            fecha2 = new Date('1/1/1990 ' + timeDesde);
            // fecha3 = new Date('1/1/1990 '+ el.horarioHasta.toString());
            fecha4 = new Date('1/1/1990 ' + timeHasta);
          }
          if ((Number(horarioDefinidoD[0]) >= Number(horarioDefinidoH[0])) || ((Number(horarioDefinidoD[0]) === Number(horarioDefinidoH[0])) && (Number(horarioDefinidoD[1]) >= Number(horarioDefinidoH[1])))) { //9/1 a 3/2     8/1 a 15/1
            // 18:00(d1) a  03:00(d2) or 18:00(d1) a 18:00(d2)
            fecha1 = new Date('1/1/1990 ' + el.horarioDesde.toString());
            // fecha2 = new Date('1/1/1990 '+ timeDesde);
            fecha3 = new Date('1/2/1990 ' + el.horarioHasta.toString());
            // fecha4 = new Date('1/2/1990 '+ timeHasta);              
          } else {
            //00:01(d1) a 23:59(d1) d1 de 0 a 24 hs 
            fecha1 = new Date('1/1/1990 ' + el.horarioDesde.toString());
            // fecha2 = new Date('1/1/1990 '+ timeDesde);
            fecha3 = new Date('1/1/1990 ' + el.horarioHasta.toString());
            // fecha4 = new Date('1/1/1990 '+ timeHasta);      
          }
          //    9/1      8/1             9/1     3/2               3/2      14/2          
          if (((fecha2 >= fecha1) && (fecha2 < fecha4)) && ((fecha4 <= fecha3) && (fecha4 > fecha2))) {
            bandera = true;
          }
        }
      });
      if (contador === horas.length) {
        if (!bandera) {
          abrirCerrarModal();
          Alert.show({
            message: "El Horario creado no coincide con el horario asignado de Plazas reservadas y aprobadas para esta carrera y establecimiento",
            type: "warning"
          })
          return false;
        } else {
          return true;
        }
      }
      // }
    } else {
      Alert.show({
        message: "No existe una solicitud y establecimientoseleccionado, Por favor Verifique.",
        type: "error"
      });
      return false;
    }
  }


  const validarConTutor = (data) => { //horario data debe quedar  fuera de horarioTutor
    if (horariosTutor && horariosTutor.length > 0) {
      const horas = horariosTutor;
      //setHorariosElegido(horas);
      //ver como llegar al listado de el seleccionado
      let bandera = false;
      /*if(timeDesde==="00:00" && timeHasta==="00:00" ){
        Alert.show({
          message : "Verifique el  horario de practica",
          type : "warning"
        })
        return false;
      }else{*/
      let contador = 0;
      horas.forEach((el) => {
        //  console.log(el);
        contador++;
        if (((data.dia).toString()) == el.dia) {
          let horad = timeDesde.split(/:/);
          let horah = timeHasta.split(/:/);
          let horarioDefinidoD = (el.horarioDesde.toString()).split(/:/);
          let horarioDefinidoH = (el.horarioHasta.toString()).split(/:/);
          let fEe;
          let fEi;
          let fSe;
          let fSi;
          // control solo cada 24 hs
          if ((Number(horad[0]) >= Number(horah[0])) || ((Number(horad[0]) === Number(horah[0])) && (Number(horad[1]) >= Number(horah[1])))) { //9/1 a 3/2     8/1 a 15/1
            // 18:00(d1) a  03:00(d2) or 18:00(d1) a 18:00(d2)
            //fecha1 = new Date('1/1/1990 '+ el.horarioDesde.toString());
            fEi = new Date('1/1/1990 ' + timeDesde);
            //fecha3 = new Date('1/2/1990 '+ el.horarioHasta.toString());
            fSi = new Date('1/2/1990 ' + timeHasta);
          } else {
            //00:01(d1) a 23:59(d1) d1 de 0 a 24 hs 
            //fecha1 = new Date('1/1/1990 '+ el.horarioDesde.toString());
            fEi = new Date('1/1/1990 ' + timeDesde);
            // fecha3 = new Date('1/1/1990 '+ el.horarioHasta.toString());
            fSi = new Date('1/1/1990 ' + timeHasta);
          }
          if ((Number(horarioDefinidoD[0]) >= Number(horarioDefinidoH[0])) || ((Number(horarioDefinidoD[0]) === Number(horarioDefinidoH[0])) && (Number(horarioDefinidoD[1]) >= Number(horarioDefinidoH[1])))) { //9/1 a 3/2     8/1 a 15/1
            // 18:00(d1) a  03:00(d2) or 18:00(d1) a 18:00(d2)
            fEe = new Date('1/1/1990 ' + el.horarioDesde.toString());
            // fecha2 = new Date('1/1/1990 '+ timeDesde);
            fSe = new Date('1/2/1990 ' + el.horarioHasta.toString());
            // fecha4 = new Date('1/2/1990 '+ timeHasta);              
          } else {
            //00:01(d1) a 23:59(d1) d1 de 0 a 24 hs 
            fEe = new Date('1/1/1990 ' + el.horarioDesde.toString());
            // fecha2 = new Date('1/1/1990 '+ timeDesde);
            fSe = new Date('1/1/1990 ' + el.horarioHasta.toString());
            // fecha4 = new Date('1/1/1990 '+ timeHasta);      
          }
          // Ingreso:  de 1 a 10     tutor trabaaj de 8 a 14
          //   01/1    8/1     01/1  14/1        10/2  14/1           10/1   01/1       
          if (((fEi >= fEe) && (fEi < fSe)) || ((fSi <= fSe) && (fSi > fEe))) {
            bandera = true;
          }
        }
      });
      if (contador === horas.length) {
        if (bandera) {
          //abrirCerrarModal();
          Alert.show({
            message: "El tutor no puede ejercer tutoría en este horario, coincide con su horario laboral",
            type: "warning"
          })
          return false;
        } else {
          return true;
        }
      }
      // }
    } else {
      Alert.show({
        message: "No existe un horario laboral establecido para el tutor.",
        type: "warning"
      });
      return true;
    }
  }








  /*MODAL*/
  const [modal, setModal] = useState(false);
  const abrirCerrarModal = () => {
    setModal(!modal);
  }
  const cerrarModal = () => {
    setModal(!modal);
  }

    //  <Box sx={classes.box}>
    const bodyModal= (
    
      <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
          <Card>
          <CardContent>
            <div>
          
                <Typography variant="h6" className={classes.title} >
                Horario Asignado Aprobado por DNERHS
              </Typography>
            
            </div>     
           
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">      
              <Grid item xs={12} className={classes.field}> 
                <Typography  align="center"
                                  variant="h6"
                                  color="primary">
                  Carrera Seleccionada:
                </Typography>  
                <Typography  align="center"
                                  variant="h6"
                                  color="primary">
                   {plazaElegida?.carreraprograma?.descripcion}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.field} >                              
                <Typography align="center"
                                  variant="h6"
                                  color="primary">
                  Establecimiento Seleccionado: 
                </Typography>  
                <Typography  align="center"
                                  variant="h6"
                                  color="primary">
                 {plazaElegida?.datosEstablecimiento?.institucionEstablecimiento?.nombreServicio?.nombre}
                </Typography>  
              </Grid>
             
            </Grid> 
            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                  <Table aria-label="Datos estadisticos">
                                    <TableHead>
                                      <TableRow>
                                        
                                        <TableCell align="center">Día</TableCell>
                                        <TableCell align="right">
                                          Horario Desde
                                        </TableCell>
                                        <TableCell align="right">
                                          Horario Hasta
                                        </TableCell>
                                        
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {horariosElegido
                                        .sort((a, b) =>
                                          a.anio > b.anio ? -1 : 1
                                        )
                                        .map((row, index) => (
                                          <TableRow key={index}>
                                          
  
                                            <TableCell align="center">
                                              {
                                                DIAS_SEMANA2.find(
                                                  (item) => item.id == row.dia
                                                )?.label
                                              }
                                            </TableCell>
                                            <TableCell align="right">
                                              {row.horarioDesde}
                                            </TableCell>
                                            <TableCell align="right">
                                              {row.horarioHasta}
                                            </TableCell>
                                           
                                          </TableRow>
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>  
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">      
                     
              <Grid item className={classes.field}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={()=>cerrarModal()}>OK
                </Button>
              </Grid>
              
            </Grid>
          </CardContent>
        </Card>
      </div>
      
    )
  
  
  
    return (
      <div>
        <Grid item xs={12}>
          <Typography align="center" variant="h5" color="primary">
          Datos cronograma
          </Typography>
        </Grid>
        <div>
          <FormProvider {...methods}>
            <form>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
              >
                <Grid container item xs={12}>
                          <Grid item xs={6}>
                            <Grid item xs={12} className={classes.field}>
                              <FormAutocomplete
                                options={estudiantesResponseData}
                                getOptionLabel={getOptionLabelEstudiantes}
                                getOptionSelected={(option, value) =>
                                  option.convenio.id === value.convenio.id &&
                                  option.estudiante.id === value.estudiante.id
                                }
                                name="convenioEstudiante"
                                label="Estudiante"
                                disabled={isReadOnly || disabledEstudiante}
                                required
                                errorobj={errors}
                              />
                            </Grid>
                            
                            <Grid item xs={12} className={classes.field}>
                              <FormAutocomplete
                           
                              
                                options={plazasList}
                                getOptionLabel={getOptionLabelPlazas}
                                getOptionSelected={(option, value) =>
                                  option.id === value.id
                                }
                                name="establecimiento"
                                label="Solicitudes de Plazas"
                                // disabled={isReadOnly || disabledPlazas}
                                required
                                errorobj={errors}                             
                                onInputChange={(e, item) => onChangeSolicitud(e, item)}
                              />
                            </Grid>
                            <Grid item xs={12} className={classes.field}>
                              <FormInput
                                name="totalHoras"
                                type="number"
                                label="Total horas"
                                disabled={isReadOnly}
                                required
                                errorobj={errors}
                              />
                            </Grid>
                            <Grid item xs={12} className={classes.field}>
                              <FormAutocomplete
                                options={tutoresConvenioList}
                                getOptionLabel={getOptionLabelTutores}
                                getOptionSelected={(option, value) =>
                                  option.convenio.id === value.convenio.id &&
                                  option.tutor.id === value.tutor.id
                                }
                                name="convenioTutor"
                                label="Tutor"
                                disabled={isReadOnly || disabledTutor}
                                required
                                errorobj={errors}
                                onInputChange={(e, item) => onChangeTutor(e, item)}
  
                              />
                            </Grid>
                           
                          </Grid>
  
                          <Grid item xs={6}>
                            <Grid item xs={12} className={classes.field}>
                              <FormInput
                                name="anio"
                                type="number"
                                label="Año"
                                disabled
                                required
                                errorobj={errors}
                              />
                            </Grid>       
                            <Grid item xs={12} className={classes.field}>
                              <FormDatePicker name="fechaDesdeModal" label="Fecha desde" disabled/>
                            </Grid>                   
                            <Grid item xs={12} className={classes.field}>
                              <FormDatePicker name="fechaHastaModal" label="Fecha hasta" disabled />
                            </Grid>
                           
                            
                            
                          </Grid>
                        </Grid>
              </Grid>
              
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                
                
                {!isAdmin &&
                  (!isUpdate ? (
                    <Grid item className={classes.field}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isReadOnly}
                      >
                        Guardar
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item className={classes.field}>
                      <Button
                        variant="contained"
                        color="primary"
                         onClick={handleSubmit(onSubmit)}
                        disabled={isReadOnly}
                      >
                        Editar
                      </Button>
                    </Grid>
                  ))
                }
              </Grid>
              {(!isAdmin) && (
                  <Grid item xs={12}>
                    <Box paddingTop={3}>
                      <FormProvider {...methods2}>
                        <form>
                          <Grid container direction="row">
                            <Grid item xs={4}>
                              <Grid item xs={12} className={classes.field}>
                                <Typography
                                  align="left"
                                  variant="h6"
                                  color="primary"
                                >
                                  Nuevo horario
                                </Typography>
                              </Grid>
                              
                              <Grid item xs={12} className={classes.field}>
                                <FormSelect
                                  name="dia"
                                  label="Día"
                                  disabled={!isCargarHorario}
                                  options={DIAS_SEMANA2}
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} className={classes.field}>
                                <FormInput
                                  name="horarioDesde"
                                  type="time"
                                 
                                  label="Horario desde"
                                  disabled={!isCargarHorario}
                                  required
                                  defaultTime="00:00"
                                  value={timeDesde}
                                  onChange={changeTimeDesde}
  
                                  // errorobj={errors}
                                />
                              </Grid>
                              <Grid item xs={12} className={classes.field}>
                                <FormInput
                                  name="horarioHasta"
                                  type="time"
                                  label="Horario desde"
                                  disabled={!isCargarHorario}
                                  required
                                  defaultValue="00:00"
                                  value={timeHasta}
                                  onChange={changeTimeHasta}
                                  // errorobj={errors}
                                />
                              </Grid>
                              
                              <Grid item xs={12}>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-end"
                                  alignContent="flex-end"
                                >
                                  {
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      onClick={handleSubmit2(onSubmit2)}
                                      className={classes.field}
                                      disabled={!isCargarHorario ||  isReadOnly}
                                    >
                                      Agregar
                                    </Button>
                                  }
                                </Grid>
                              </Grid>
                            </Grid>
  
                            <Grid item xs={8}>
                              <Grid item xs={12} className={classes.field}>
                                <Typography
                                  align="center"
                                  variant="h6"
                                  color="primary"
                                >
                                  Horario del Alumno
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                  <Table aria-label="Datos estadisticos">
                                    <TableHead>
                                      <TableRow>
                                        
                                        <TableCell align="center">Día</TableCell>
                                        <TableCell align="right">
                                          Horario Desde
                                        </TableCell>
                                        <TableCell align="right">
                                          Horario Hasta
                                        </TableCell>                                     
                                        <TableCell align="center">
                                          Acción
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {horarios
                                        .sort((a, b) =>
                                          a.anio > b.anio ? -1 : 1
                                        )
                                        .map((row, index) => (
                                          <TableRow key={index}>
                                          
  
                                            <TableCell align="center">
                                              {
                                                DIAS_SEMANA2.find(
                                                  (item) => item.id == row.dia
                                                )?.label
                                              }
                                            </TableCell>
                                            <TableCell align="right">
                                              {row.horarioDesde}
                                            </TableCell>
                                            <TableCell align="right">
                                              {row.horarioHasta}
                                            </TableCell>
                                            
                                            <TableCell align="center">
                                              <Tooltip
                                                title="Eliminar"
                                                aria-label="eliminar"
                                              >
                                                <IconButton
                                                  size="small"
                                                  aria-label="eliminar"
                                                  color="secondary"
                                                  onClick={() =>
                                                    handleOpenDialog(row.id, index)
                                                  }
                                                  disabled={isReadOnly}
  
                                                >
                                                  <DeleteIcon />
                                                </IconButton>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            </Grid>
                          </Grid>
                        </form>
                      </FormProvider>
                    </Box>
                  </Grid>
                )}
            </form>
          </FormProvider>
          <DeleteDialog
              open={openDialog}
              onClose={handleCloseDialog}
              onAccept={deleteOne}
              aria-labelledby="form-dialog-title"
            />
        </div>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="default"
              onClick={() => {
                // Si el padre estaba en modo readonly o ver, preservar ese estado
                if (state?.parentReadOnly || state?.parentIsVerMode) {
                  history.push({
                    pathname: `/convenios/cronogramasPracticas/ver/${params.convenioId}/${practicaId}`,
                    state: {
                      readOnly: true
                    }
                  });
                } else {
                  // Si no, volver en modo edición
                  history.push({
                    pathname: `/convenios/cronogramasPracticas/editar/${params.convenioId}/${practicaId}`,
                    state: {
                      edit: true
                    }
                  });
                }
              }}
            >
              Atrás
            </Button>
          </Grid>
          
          
        </Grid>
        <Modal backdrop="static"
          open={modal} variant="standard"
          InputProps={{
                  disableUnderline: true,
                }}
                style={{outline: 'none'}}
                classes={{focused: classes.outlinedInputFocused}}
        >
        
          {bodyModal}
        </Modal>
      </div>
    );

};

export default Form;
